import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AccountService {
    static getPotentialExistingAccounts(
        accountSearchCritera,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getPotentialExistingAccounts',
            [accountSearchCritera],
            additionalHeaders
        );
    }

    static getAccountDetails(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountDetails',
            [accountNumber],
            additionalHeaders
        );
    }

    static getAccountBillingData(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountBillingData',
            [accountNumber],
            additionalHeaders
        );
    }

    static addRecentlyViewedAccounts(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'addRecentlyViewedAccounts',
            [accountNumber],
            additionalHeaders
        );
    }

    static getRecentlyViewedAccounts(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getRecentlyViewedAccounts',
            [],
            additionalHeaders
        );
    }

    static getAvailableProductsForAccount(
        newSubmission,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAvailableProductsForAccount',
            [newSubmission],
            additionalHeaders
        );
    }

    static getAccountClaims(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountClaims',
            [accountNumber],
            additionalHeaders
        );
    }

    static getAccountsForCurrentUser(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountsForCurrentUser',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getPersonalAccountsForCurrentUser(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getPersonalAccountsForCurrentUser',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getCommercialAccountsForCurrentUser(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getCommercialAccountsForCurrentUser',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getAccountsForProducerCode(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountsForProducerCode',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getPersonalAccountsForProducerCode(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getPersonalAccountsForProducerCode',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getCommercialAccountsForProducerCode(
        createdInLastXDays,
        queryOptions,
        queryParameters,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getCommercialAccountsForProducerCode',
            [createdInLastXDays, queryOptions, queryParameters],
            additionalHeaders
        );
    }

    static getOpenPolicyTransactionsForAccount(
        accountNumber,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getOpenPolicyTransactionsForAccount',
            [accountNumber],
            additionalHeaders
        );
    }

    static getOrCreateAccount(account, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getOrCreateAccount',
            [account],
            additionalHeaders
        );
    }

    static getAccountJobsSummariesForCurrentUser(
        createdInLastXDays,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsSummariesForCurrentUser',
            [createdInLastXDays],
            additionalHeaders
        );
    }

    static getAccountJobsSummariesForCurrentUser_TWIA(
        producerCode,
        createdInLastXDays,
        status,
        lobCodes,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsSummariesForCurrentUser_TWIA',
            [producerCode, createdInLastXDays, status, lobCodes],
            additionalHeaders
        );
    }

    static getAccountJobsSummariesForCurrentUser_TFPA(
        producerCode,
        createdInLastXDays,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsSummariesForCurrentUser_TFPA',
            [producerCode, createdInLastXDays],
            additionalHeaders
        );
    }

    static updateAccountDetails(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'updateAccountDetails',
            [accountNumber],
            additionalHeaders
        );
    }

    static getAccountJobsForCurrentUser(noOfDays, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobsForCurrentUser',
            [noOfDays],
            additionalHeaders
        );
    }

    static getAccountJobTypesForCurrentUser_TWIA(
            producerCode, noOfDays, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'getAccountJobTypesForCurrentUser_TWIA',
            [producerCode, noOfDays],
            additionalHeaders
        );
    }

    // US30038: Fix Abandoned CE Registrations
    static updateAccountCEUsername_TWIA(username, acccountNumbers, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayAccount'),
            'updateAccountCEUsername_TWIA',
            [username, acccountNumbers],
            additionalHeaders
        );
    }    
}
